import { RefObject, useRef } from 'react';
import { ButtonPositionType } from 'interfaces/betslip';

type ReturnType = {
  getButtonPosition: () => ButtonPositionType;
  buttonRef: RefObject<HTMLButtonElement | HTMLDivElement>;
};
const POPOVER_WIDTH_COUNT = 280;
const ODD_POSITION = 4;

const BUTTON_OFFSET_VALUE = 32;

export const useOddButtonPosition = (): ReturnType => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  const _buttonPosition = (): ButtonPositionType => {
    if (buttonRef.current) {
      const { offsetLeft } = buttonRef.current;
      const { innerWidth } = window;

      if (
        buttonRef.current?.getBoundingClientRect()?.top < POPOVER_WIDTH_COUNT
      ) {
        if (offsetLeft > (innerWidth - BUTTON_OFFSET_VALUE) / 2) {
          return 'bottomRight';
        } else {
          if (offsetLeft > (innerWidth - BUTTON_OFFSET_VALUE) / ODD_POSITION) {
            return 'bottom';
          }

          return 'bottomLeft';
        }
      }

      if (offsetLeft > (innerWidth - BUTTON_OFFSET_VALUE) / 2) {
        return 'topRight';
      } else {
        if (offsetLeft > (innerWidth - BUTTON_OFFSET_VALUE) / ODD_POSITION) {
          return 'top';
        }

        return 'topLeft';
      }
    }

    return 'topLeft';
  };

  return {
    buttonRef,
    getButtonPosition: _buttonPosition
  };
};
